import JQuery from 'jquery'
import {Facade_Logger} from '../facades/facade_logger';

let $ = JQuery

/**
 * base request-implementation abstractor
*/
const Api_Clients_Base={
    
    //#######################################
    //request libraries implementations
    //#######################################

    /**
     * make ajax request using jquery
     * 
     * @param {object} api_request_data the request body
     * @param {string} api_url the request url
     * 
     * @return {Promise}
    */
    make_post_request_jquery:function(api_request_data,api_url)
    {
		//prepare request data
		var post_data=JSON.stringify(api_request_data);

		//set request options
		var ajax_settings={
            url:api_url,
			async:true,
			method:"POST",
            contentType:"application/json",
            dataType:"json",
			data:post_data,
            crossDomain:true,
            xhrFields:{
                //if the server-side has Acces-Control-Allow-Origin:"*"
                //with credentials on the client-side must be false
                withCredentials:false
            }
		};

		//launch request using promise to handle result
		return $.ajax(ajax_settings);
    },
    make_get_request_jquery:function(api_url)
    {
		//set request options
		var ajax_settings={
            url:api_url,
			async:true,
			method:"GET",
            //contentType:"application/json",
            //crossDomain:true,
            xhrFields:{
                //if the server-side has Acces-Control-Allow-Origin:"*"
                //with credentials on the client-side must be false
                //withCredentials:false
            }
		};

		//launch request using promise to handle result
		return $.ajax(ajax_settings);
    },


    //#######################################
    //request process
    //#######################################

    /**
     * make ajax request
     * 
     * @param {object} api_request_data the request body
     * @param {string} api_url the request url
     * 
     * @return {Promise}
    */
    make_post_request:function(api_request_data,api_url)
    {
        return new Promise(
            function(resolve_func,reject_func)
            {
                //=====================
                //log request
                //=====================
                Facade_Logger.log("==>making ajax POST-request=>"+api_url);
                Facade_Logger.log(api_request_data);

                //make library request
                Api_Clients_Base.make_post_request_jquery(api_request_data,api_url).then(
                    function(data,)
                    {
                        //=====================
                        //log response
                        //=====================
                        Facade_Logger.log("==>parsing response data=>"+api_url);
                        Facade_Logger.log(data);

                        //=====================
                        //hand off response
                        //=====================
                        resolve_func(data)
                    },
                    function(error)
                    {
                        reject_func(error)
                    }
                )
            }
        );
    },
    /**
     * make ajax request
     * 
     * @param {string} api_url the request url
     * 
     * @return {Promise}
    */
   make_get_request:function(api_url)
   {
       return new Promise(
           function(resolve_func,reject_func)
           {
               //=====================
               //log request
               //=====================
               Facade_Logger.log("==>making ajax GET-request=>"+api_url);

               //make library request
               Api_Clients_Base.make_get_request_jquery(api_url).then(
                   function(data)
                   {
                       //=====================
                       //log response
                       //=====================
                       Facade_Logger.log("==>parsing response data=>"+api_url);
                       Facade_Logger.log(data);

                       //=====================
                       //hand off response
                       //=====================
                       resolve_func(data)
                   },
                   function(error)
                   {
                       reject_func(error)
                   }
               )
           }
       );
   }
}

const Api_Client_E4e_Fmoh_Iss={
    
    /**
     * the url base
     * 
     * @param {string} param_cant_str the resource part of the url to be cantecated to the base
     * 
     * @return {string}
    */
    _base_url:function(param_cant_str)
    {
        //set the base url for api endpoints
        //e,g "http://service/api/"+param_cant_str="http://service/api/message/new"
        //return ((window.location.origin)+param_cant_str);

        //check if this is beign run form `npm run serve` on localhost
        //if true use the local_url FMOH-ISS in the config file
        //else use the window origin
        if((window.location.origin).search("localhost")==-1)
        {
            return (window.location.origin)+"/"+param_cant_str+"/";
        }
        else
        {
            return (CONFIG.URL_FMOH_ISS+param_cant_str+"/");
        }
    },

    //###################################################################
    //API REQUESTS
    //###################################################################

    /**
     * make ajax request to this route
     * 
     * @param {number} param_items_per_page
     * @param {number} param_page
     * 
     * @return {Promise}
    */
    forms_action_get_submissions_summary:function(
        param_username,
        param_form_name,
        param_form_id,
        param_items_per_page,
        param_page
    )
    {
        return Api_Clients_Base.make_get_request(
            Api_Client_E4e_Fmoh_Iss._base_url(
                "extension/api/submission/all_summary/"+param_items_per_page+"/"+param_page+"/"+param_username+"/"+param_form_name
            )
        )
    },
    /**
     * make ajax request to this route
     * 
     * @param {number} param_items_per_page
     * @param {number} param_page
     * 
     * @return {Promise}
    */
    forms_action_get_submissions_details:function(
        param_username,
        param_form_name,
        param_form_id,
        param_items_per_page,
        param_page
    )
    {
        return Api_Clients_Base.make_get_request(
            Api_Client_E4e_Fmoh_Iss._base_url(
                "extension/api/submission/all_details/"+param_items_per_page+"/"+param_page+"/"+param_username+"/"+param_form_name
            )
        )
    },
    /**
     * make ajax request to this route
     * 
     * @param {number} param_submission_id
     * 
     * @return {Promise}
    */
    forms_action_get_submission_by_id:function(
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id
    )
    {
        return Api_Clients_Base.make_get_request(
            Api_Client_E4e_Fmoh_Iss._base_url(
                "extension/api/submission/id/"+param_submission_id+"/"+param_username+"/"+param_form_name
            )
        )
    },
    /**
     * make ajax request to this route
     * 
     * @param {number} param_submission_id
     * @param {number} param_status
     * @param {string} param_email
     * @param {string} param_note
     * 
     * @return {Promise}
    */
   forms_action_review_submission:function(
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id,
        param_status,
        param_email,
        param_note
    )
    {
        if(param_email=="")
        {
            param_email=" "
        }

        return Api_Clients_Base.make_get_request(
            Api_Client_E4e_Fmoh_Iss._base_url(
                "extension/api/submission/review/"+param_submission_id+"/"+param_status+"/"+param_email+"/"+param_note+"/"+param_username+"/"+param_form_name
            )
        )
    }
}

//EXPORTS
export {Api_Client_E4e_Fmoh_Iss};